import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import withStyles from "@material-ui/styles/withStyles";
import Plx from "react-plx";

import useWindowDimensions from "../../common/hooks/useWindowDimensions";
import { styles, backAnim } from "./Home.styles";
import Welcome from "./components/Welcome";

import { selectScrollTo, selectActiveScroll, scrollDone } from "./homeSlice";

import { animateScroll } from "react-scroll";
import StemPods from "./components/StemPods";
import Features from "./components/Features";
import Clients from "./components/Clients";
import Portfolio from "./components/Portfolio";
import Contact from "./components/Contact";

function HomeOld({ classes }) {
  const dispatch = useDispatch();
  const scrollTo = useSelector(selectScrollTo);
  const activeScroll = useSelector(selectActiveScroll);

  const { height: viewHeight } = useWindowDimensions();

  useEffect(() => {
    if (activeScroll) {
      animateScroll.scrollTo(viewHeight * scrollTo);
      dispatch(scrollDone());
    }
    console.log("scrollTo: %o", scrollTo);
    // eslint-disable-next-line
  }, [scrollTo]);

  return (
    <div className={classes.root}>
      <Plx
        className={classes.background}
        parallaxData={backAnim({ viewHeight })}
      ></Plx>
      <div className={classes.screen}>
        <Welcome />
      </div>
      <div className={classes.screen}>
        <Clients screen={1}/>
      </div>
      <div className={classes.screen}>
        <Features />
      </div>
      <div className={classes.screen}>
        <StemPods screen={3} />
      </div>
      <div className={classes.screen}>
        <Contact />
      </div>
      <div className={classes.screen}>
        <Portfolio />
      </div>
    </div>
  );
}

export default withStyles(styles)(HomeOld);
